import { createContext } from "react";
import { Logger } from "@datadog/browser-logs";

const loggerContext = createContext<Logger | undefined>(undefined);

export default loggerContext;
